import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.sub.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, map, of, switchMap } from 'rxjs';
import { BN_BILLION, BN_ZERO } from '@polkadot/util';
import { firstMemo, memo } from "../util/index.js";

function parseRewards(api, stashId, _ref, exposures) {
  var _ref2 = _slicedToArray(_ref, 3),
      erasPoints = _ref2[0],
      erasPrefs = _ref2[1],
      erasRewards = _ref2[2];

  return exposures.map(function (_ref3) {
    var era = _ref3.era,
        isEmpty = _ref3.isEmpty,
        isValidator = _ref3.isValidator,
        nominating = _ref3.nominating,
        eraValidators = _ref3.validators;

    var _ref4 = erasPoints.find(function (p) {
      return p.era.eq(era);
    }) || {
      eraPoints: BN_ZERO,
      validators: {}
    },
        eraPoints = _ref4.eraPoints,
        allValPoints = _ref4.validators;

    var _ref5 = erasRewards.find(function (r) {
      return r.era.eq(era);
    }) || {
      eraReward: api.registry.createType('Balance')
    },
        eraReward = _ref5.eraReward;

    var _ref6 = erasPrefs.find(function (p) {
      return p.era.eq(era);
    }) || {
      validators: {}
    },
        allValPrefs = _ref6.validators;

    var validators = {};
    var stakerId = stashId.toString();
    Object.entries(eraValidators).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          validatorId = _ref8[0],
          exposure = _ref8[1];

      var _allValPrefs$validato, _exposure$total;

      var valPoints = allValPoints[validatorId] || BN_ZERO;
      var valComm = ((_allValPrefs$validato = allValPrefs[validatorId]) === null || _allValPrefs$validato === void 0 ? void 0 : _allValPrefs$validato.commission.unwrap()) || BN_ZERO;
      var expTotal = ((_exposure$total = exposure.total) === null || _exposure$total === void 0 ? void 0 : _exposure$total.unwrap()) || BN_ZERO;
      var avail = BN_ZERO;
      var value;

      if (!(expTotal.isZero() || valPoints.isZero() || eraPoints.isZero())) {
        avail = eraReward.mul(valPoints).div(eraPoints);
        var valCut = valComm.mul(avail).div(BN_BILLION);
        var staked;

        if (validatorId === stakerId) {
          staked = exposure.own.unwrap();
        } else {
          var stakerExp = exposure.others.find(function (_ref9) {
            var who = _ref9.who;
            return who.eq(stakerId);
          });
          staked = stakerExp ? stakerExp.value.unwrap() : BN_ZERO;
        }

        value = avail.sub(valCut).imul(staked).div(expTotal).iadd(validatorId === stakerId ? valCut : BN_ZERO);
      }

      validators[validatorId] = {
        total: api.registry.createType('Balance', avail),
        value: api.registry.createType('Balance', value)
      };
    });
    return {
      era: era,
      eraReward: eraReward,
      isEmpty: isEmpty,
      isValidator: isValidator,
      nominating: nominating,
      validators: validators
    };
  });
}

function allUniqValidators(rewards) {
  return rewards.reduce(function (_ref10, rewards) {
    var _ref11 = _slicedToArray(_ref10, 2),
        all = _ref11[0],
        perStash = _ref11[1];

    var uniq = [];
    perStash.push(uniq);
    rewards.forEach(function (_ref12) {
      var validators = _ref12.validators;
      return Object.keys(validators).forEach(function (validatorId) {
        if (!uniq.includes(validatorId)) {
          uniq.push(validatorId);

          if (!all.includes(validatorId)) {
            all.push(validatorId);
          }
        }
      });
    });
    return [all, perStash];
  }, [[], []]);
}

function removeClaimed(validators, queryValidators, reward) {
  var rm = [];
  Object.keys(reward.validators).forEach(function (validatorId) {
    var index = validators.indexOf(validatorId);

    if (index !== -1) {
      var valLedger = queryValidators[index].stakingLedger;

      if (valLedger !== null && valLedger !== void 0 && valLedger.claimedRewards.some(function (e) {
        return reward.era.eq(e);
      })) {
        rm.push(validatorId);
      }
    }
  });
  rm.forEach(function (validatorId) {
    delete reward.validators[validatorId];
  });
}

function filterRewards(eras, valInfo, _ref13) {
  var rewards = _ref13.rewards,
      stakingLedger = _ref13.stakingLedger;
  var filter = eras.filter(function (e) {
    return !stakingLedger.claimedRewards.some(function (s) {
      return s.eq(e);
    });
  });
  var validators = valInfo.map(function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 1),
        v = _ref15[0];

    return v;
  });
  var queryValidators = valInfo.map(function (_ref16) {
    var _ref17 = _slicedToArray(_ref16, 2),
        q = _ref17[1];

    return q;
  });
  return rewards.filter(function (_ref18) {
    var isEmpty = _ref18.isEmpty;
    return !isEmpty;
  }).filter(function (reward) {
    if (!filter.some(function (e) {
      return reward.era.eq(e);
    })) {
      return false;
    }

    removeClaimed(validators, queryValidators, reward);
    return true;
  }).filter(function (_ref19) {
    var validators = _ref19.validators;
    return Object.keys(validators).length !== 0;
  }).map(function (reward) {
    return _objectSpread(_objectSpread({}, reward), {}, {
      nominators: reward.nominating.filter(function (n) {
        return reward.validators[n.validatorId];
      })
    });
  });
}

export function _stakerRewardsEras(instanceId, api) {
  return memo(instanceId, function (eras) {
    var withActive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return combineLatest([api.derive.staking._erasPoints(eras, withActive), api.derive.staking._erasPrefs(eras, withActive), api.derive.staking._erasRewards(eras, withActive)]);
  });
}
export function _stakerRewards(instanceId, api) {
  return memo(instanceId, function (accountIds, eras) {
    var withActive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return combineLatest([api.derive.staking.queryMulti(accountIds, {
      withLedger: true
    }), api.derive.staking._stakerExposures(accountIds, eras, withActive), api.derive.staking._stakerRewardsEras(eras, withActive)]).pipe(switchMap(function (_ref20) {
      var _ref21 = _slicedToArray(_ref20, 3),
          queries = _ref21[0],
          exposures = _ref21[1],
          erasResult = _ref21[2];

      var allRewards = queries.map(function (_ref22, index) {
        var stakingLedger = _ref22.stakingLedger,
            stashId = _ref22.stashId;
        return !stashId || !stakingLedger ? [] : parseRewards(api, stashId, erasResult, exposures[index]);
      });

      if (withActive) {
        return of(allRewards);
      }

      var _allUniqValidators = allUniqValidators(allRewards),
          _allUniqValidators2 = _slicedToArray(_allUniqValidators, 2),
          allValidators = _allUniqValidators2[0],
          stashValidators = _allUniqValidators2[1];

      return api.derive.staking.queryMulti(allValidators, {
        withLedger: true
      }).pipe(map(function (queriedVals) {
        return queries.map(function (_ref23, index) {
          var stakingLedger = _ref23.stakingLedger;
          return filterRewards(eras, stashValidators[index].map(function (validatorId) {
            return [validatorId, queriedVals.find(function (q) {
              return q.accountId.eq(validatorId);
            })];
          }), {
            rewards: allRewards[index],
            stakingLedger: stakingLedger
          });
        });
      }));
    }));
  });
}
export var stakerRewards = firstMemo(function (api, accountId, withActive) {
  return api.derive.staking.erasHistoric(withActive).pipe(switchMap(function (eras) {
    return api.derive.staking._stakerRewards([accountId], eras, withActive);
  }));
});
export function stakerRewardsMultiEras(instanceId, api) {
  return memo(instanceId, function (accountIds, eras) {
    return accountIds.length && eras.length ? api.derive.staking._stakerRewards(accountIds, eras, false) : of([]);
  });
}
export function stakerRewardsMulti(instanceId, api) {
  return memo(instanceId, function (accountIds) {
    var withActive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return api.derive.staking.erasHistoric(withActive).pipe(switchMap(function (eras) {
      return api.derive.staking.stakerRewardsMultiEras(accountIds, eras);
    }));
  });
}